import React, { useEffect, useState } from "react";
import { getCallStats } from "../../utils/api/callAPI";
import { useSelector } from "react-redux";
import { walletAPI } from "../../utils/api/WalletAPI";

export const UnitCountSeven = () => {
  const [numberOfCalls, setNumberOfCalls] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (!user || !user?.organizationId) return;

    setLoading(true);
    Promise.all([
      walletAPI({ organizationId: user?.organizationId }),
      getCallStats()
    ])
      .then(([walletData, callStats]) => {
        setSummary(walletData);
        setMinutes(Number(callStats?.totalMinutes?.toFixed(2)) || 0);
        setNumberOfCalls(callStats?.totalCalls || 0);
      })
      .finally(() => setLoading(false));
  }, [user]);

  const shimmerCard = () => (
    <div className='col-xxl-3 col-xl-4 col-sm-6'>
      <div className='px-20 py-16 shadow-none radius-8 h-100 shimmer'>
        <div className='mb-3 shimmer-text'></div>
        <div className='shimmer-text'></div>
      </div>
    </div>
  );

  return (
    <div className='col-12'>
      <div className='card radius-12'>
        <div className='card-body p-18'>
          <div className='row gy-4'>
            {loading ? (
              <>
                {shimmerCard()}
                {shimmerCard()}
                {shimmerCard()}
                {shimmerCard()}
              </>
            ) : (
              <>
                <div className='col-xxl-3 col-xl-4 col-sm-6'>
                  <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-1 left-line line-bg-primary position-relative overflow-hidden'>
                    <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                      <div>
                        <span className='mb-2 fw-medium text-secondary-light text-md'>
                          Total Minutes
                        </span>
                        <h6 className='fw-semibold mb-1'>{minutes}</h6>
                      </div>
                      <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-primary-100 text-primary-600'>
                        <i className='ri-time-fill' />
                      </span>
                    </div>
                  </div>
                </div>

                <div className='col-xxl-3 col-xl-4 col-sm-6'>
                  <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-2 left-line line-bg-lilac position-relative overflow-hidden'>
                    <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                      <div>
                        <span className='mb-2 fw-medium text-secondary-light text-md'>
                          Number Of Calls
                        </span>
                        <h6 className='fw-semibold mb-1'>{numberOfCalls}</h6>
                      </div>
                      <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-lilac-200 text-lilac-600'>
                        <i className='ri-phone-fill' />
                      </span>
                    </div>
                  </div>
                </div>

                <div className='col-xxl-3 col-xl-4 col-sm-6'>
                  <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-4 left-line line-bg-warning position-relative overflow-hidden'>
                    <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                      <div>
                        <span className='mb-2 fw-medium text-secondary-light text-md'>
                          Credit Used
                        </span>
                        <h6 className='fw-semibold mb-1'>
                          {(summary?.creditsUsed / 60).toFixed(2)}
                        </h6>
                      </div>
                      <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-warning-focus text-warning-600'>
                        <i className='ri-arrow-up-circle-fill' />
                      </span>
                    </div>
                  </div>
                </div>

                <div className='col-xxl-3 col-xl-4 col-sm-6'>
                  <div className='px-20 py-16 shadow-none radius-8 h-100 gradient-deep-3 left-line line-bg-success position-relative overflow-hidden'>
                    <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                      <div>
                        <span className='mb-2 fw-medium text-secondary-light text-md'>
                          Remaining Credits
                        </span>
                        <h6 className='fw-semibold mb-1'>
                          {(summary?.creditsRemaining / 60).toFixed(2)}
                        </h6>
                      </div>
                      <span className='w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 bg-success-200 text-success-600'>
                        <i className='ri-wallet-3-fill' />
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountSeven;
